import KFullscreenDialog from "./KFullscreenDialog";

export default {
	name: "KPdfDialog",

	props: {
		...KFullscreenDialog.options.props,

		baseURL: {
			default: "/rest/pdf",
			type: String
		},

		src: {
			required: true,
			type: String
		},

		value: {
			default: "auto",
			type: [ String, Boolean ],
			validator: value => typeof value === "boolean" || value === "auto"
		}
	},

	data: () => ( {
		autoValue: false,
		pdfLoading: false,
		pdfSrc: null
	} ),

	computed: {
		autoModel() {
			return this.value === "auto";
		},

		internalValue: {
			get() {
				if ( this.autoModel ) {
					return this.autoValue;
				}

				return this.value;
			},

			set( val ) {
				if ( this.autoModel ) {
					this.autoValue = val;
				}

				this.$emit( "input", val );
			}
		}
	},

	watch: {
		internalValue( val ) {
			if ( val ) {
				this.getPDF();
			}
		}
	},

	methods: {
		getPDF() {
			this.pdfSrc = null;
			this.pdfLoading = true;

			return this.$http.get( this.src, {
				baseURL: this.baseURL,
				responseType: "blob"
			} )
			.then( ( response, reject ) => {
				this.pdfLoading = false;

				if ( response.status === 200 && response.data && response.data.size ) {
					this.pdfSrc = URL.createObjectURL( response.data );
				} else {
					reject();
				}
			} );
		}
	},

	render() {
		return <KFullscreenDialog
			attrs={{
				...this.$props,
				loading: this.loading || this.pdfLoading
			}}
			bodyClasses="overflow-y-hidden"
			scopedSlots={{
				default: () =>
					<iframe
						src={this.pdfSrc}
						style="border: 0; height: 100%; width: 100%;"
					></iframe>,

				...this.$scopedSlots
			}}
			vModel={this.internalValue}
		></KFullscreenDialog>;
	}
};
